import * as VueRouter from 'vue-router';
import {refreshDocumentMeta} from "./Utils/DocumentMeta";

// Layout Pages
const PageView = () => import('./Views/PageView/PageView.vue');
const NewsListView = () => import('./Views/NewsListView/NewsListView.vue');
const NewsPageView = () => import('./Views/NewsPageView/NewsPageView.vue');
const BlogListView = () => import('./Views/BlogListView/BlogListView.vue');
const BlogPageView = () => import('./Views/BlogPageView/BlogPageView.vue');
const NotFoundView = () => import('./Views/NotFoundView/NotFoundView.vue');

const routes = [
	{
		path: '/',
		name: 'home',
		component: PageView,
	},
	{
		path: '/:permalink',
		name: 'page-view',
		alias: ['/landing/:permalink', '/page/:permalink'],
		component: PageView,
	},
	{
		path: '/news',
		name: 'news',
		component: NewsListView,
	},
	{
		path: '/news/:slug',
		name: 'news-detail',
		component: NewsPageView,
	},
	{
		path: '/blogs',
		name: 'blog',
		component: BlogListView,
	},
	{
		path: '/blogs/:slug',
		name: 'blog-detail',
		component: BlogPageView,
	},

	// The server answers an unknown address with a real 404 page; this is for the addresses opened inside the application
	{path: '/:pathMatch(.*)*', name: '404', component: NotFoundView},
];

const router = VueRouter.createRouter({
	history: VueRouter.createWebHistory(),
	routes,
});

router.beforeEach(async (to, from, next) => {
	// const store = useAuthStore();
	//
	// if ((to.name !== 'login' && to.name !== 'register') && !store.isLoggedIn) {
	// 	next({name: "login"});
	// } else if ((to.name === 'login' || to.name === 'register') && store.isLoggedIn) {
	// 	next({name: 'dashboard'});
	// } else if (store.isLoggedIn === false && to.meta.auth === true) {
	// 	await Sweetalert2.fire({
	// 		title: 'Kérlek jelentkezz be az oldal megtekintéséhez!',
	// 		icon: 'warning',
	// 		confirmButtonColor: 'var(--colorMain)',
	// 		confirmButtonText: 'OK'
	// 	});
	// 	await router.push({name: 'home'});
	// 	return;
	// }
	// // Otherwise allowed viewing..
	// if (store.isLoggedIn && !store.isLoaded) {
	// 	await store.getMe();
	// }
	next();
});

// Title, description, canonical and the sharing tags follow the route (the first page has them in the HTML answer)
router.afterEach((to, from) => {
	if (from !== VueRouter.START_LOCATION) {
		refreshDocumentMeta(to);
	}
});

export default router;
